import React from "react";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";

import { AppRoutes, routes } from "AppRoutes";
import { IAppInfo } from "infrastructure";
import { LocalStorage } from "infrastructure/store";
import { AppLocalizer, ErrorHandler, AppRoot, UserProvider } from "ui/app";
import { FullScreenLayout } from "ui/app/layout";
import { DefaultRouter, DialogRouter } from "ui/app/navigation";

export interface IAppProps {
  appInfo: IAppInfo;
  applyTheme: (theme: string) => void;
  storage: LocalStorage;
}

export const App: React.FC<IAppProps> = ({ appInfo, applyTheme, storage }) => {
  return (
    <Provider store={storage.getStore()}>
      <PersistGate persistor={storage.getPersistor()}>
        <DefaultRouter>
          <AppRoot appInfo={appInfo} applyTheme={applyTheme} routes={routes}>
            <ErrorHandler layout={FullScreenLayout}>
              <AppLocalizer>
                <DialogRouter routes={routes}>
                  <UserProvider>
                    <AppRoutes />
                  </UserProvider>
                </DialogRouter>
              </AppLocalizer>
            </ErrorHandler>
          </AppRoot>
        </DefaultRouter>
      </PersistGate>
    </Provider>
  );
};
